var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"query"},[_c('Filters',{attrs:{"type":"search","filters":_vm.filters,"toggleLabel":"Search","addDefault":true},on:{"save":_vm.search}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }